export function assertDataIsNotResponse<T extends object>(data: Response | T): asserts data is T {
    if ('json' in data && typeof data.json == 'function') {
        throw new Error('data is Response.');
    }
}

export function assertUnreachable(x: never): never {
    throw new Error(`Didn't expect to get ${x}`);
}
